<template>
  <div :class="classes">
    <pt-page-title title="客户详情"></pt-page-title>
    <pt-sub-title title="客户信息"></pt-sub-title>
    <div v-if="vendorData && vendorData.base">
      <pt-form-item label="客户名称：" :labelWidth="labelWidth" :lineHeight="lineHeight" :labelColor="labelColor">
        <span>{{vendorData.base.name}}</span>
      </pt-form-item>
      <pt-form-item label="联系人：" :labelWidth="labelWidth" :lineHeight="lineHeight" :labelColor="labelColor">
        <span>{{vendorData.base.contact}}</span>
      </pt-form-item>
      <pt-form-item label="手机号：" :labelWidth="labelWidth" :lineHeight="lineHeight" :labelColor="labelColor">
        <span>{{vendorData.base.mobile}}</span>
      </pt-form-item>
        <pt-form-item label="身份证号：" :labelWidth="labelWidth" :lineHeight="lineHeight" :labelColor="labelColor">
          <span>{{ vendorData.base.cardId }}</span>
        </pt-form-item>
      <pt-form-item label="邮箱：" :labelWidth="labelWidth" :lineHeight="lineHeight" :labelColor="labelColor">
        <span>{{vendorData.base.email}}</span>
      </pt-form-item>
      <pt-form-item label="通讯地址：" :labelWidth="labelWidth" :lineHeight="lineHeight" :labelColor="labelColor">
        <span>{{vendorData.base.address.postAddress}}</span>
      </pt-form-item>
      <pt-sub-title title="客户企业信息"></pt-sub-title>
      <pt-form-item label="社会统一信用代码：" :labelWidth="labelWidth" :lineHeight="lineHeight" :labelColor="labelColor">
        <span>{{vendorData.base.secCode}}</span>
      </pt-form-item>
      <pt-form-item label="营业执照副本：" :labelWidth="labelWidth" :lineHeight="lineHeight" :labelColor="labelColor">
        <!-- <span v-for="(item,i) in vendorData.base.licenses" :key="i" :class="$style.special">{{item.name}}</span> -->
         <a style="margin-right:20px;vertical-align:middle;" :href="$privateResourcesUrl+item.url" target="_blank" v-for="(item,i) in vendorData.base.licenses" :key="i" :class="$style.special">{{item.name}}</a>
      </pt-form-item>
      <pt-form-item label="其他资质证照：" :labelWidth="labelWidth" v-if="vendorData.base.qualifications" :lineHeight="lineHeight" :labelColor="labelColor">
        <pt-img v-for="(item,index) in vendorData.base.qualifications" :key="index"  :src="item.url" :isPublic="false" :class="$style.quaImages"></pt-img>
        <ul :class="$style.pictureNames">
          <li v-for="(item,index) in vendorData.base.qualifications" :key="index">{{item.name}}</li>
        </ul>
      </pt-form-item>
      <pt-form-item label="代售合同：" :labelWidth="labelWidth" :lineHeight="lineHeight" :labelColor="labelColor">
        <a style="margin-right:20px;vertical-align:middle;" :href="$privateResourcesUrl+item.url" target="_blank" v-for="(item,i) in vendorData.base.contracts" :key="i" :class="$style.special">{{item.name}}</a>
      </pt-form-item>
      <pt-sub-title title="客户开票信息"></pt-sub-title>
      <pt-form-item label="开票类型：" :labelWidth="labelWidth" :lineHeight="lineHeight" :labelColor="labelColor">
        <span>{{formatInvoiceType(vendorData.invoice.type)}}</span>
      </pt-form-item>
      <pt-form-item label="可开具发票类型：" :labelWidth="labelWidth" :lineHeight="lineHeight" :labelColor="labelColor">
        <span v-if="vendorData.invoice.ableType">{{vendorData.invoice.ableType.map(e=>formatInvoiceProvideType(e)).toString()}}</span>
      </pt-form-item>
      <pt-form-item label="发票抬头：" :labelWidth="labelWidth" :lineHeight="lineHeight" :labelColor="labelColor">
        <span>{{vendorData.invoice.title}}</span>
      </pt-form-item>
      <pt-form-item label="纳税人识别号：" :labelWidth="labelWidth" :lineHeight="lineHeight" :labelColor="labelColor">
        <span>{{vendorData.invoice.taxId}}</span>
      </pt-form-item>
      <pt-form-item label="公司地址：" :labelWidth="labelWidth" :lineHeight="lineHeight" :labelColor="labelColor">
        <span>{{vendorData.invoice.companyAddress}}</span>
      </pt-form-item>
      <pt-form-item label="公司电话：" :labelWidth="labelWidth"  :lineHeight="lineHeight" :labelColor="labelColor">
        <span>{{vendorData.invoice.companyTel}}</span>
      </pt-form-item>
      <pt-form-item label="开户银行：" :labelWidth="labelWidth" :lineHeight="lineHeight" :labelColor="labelColor">
        <span>{{vendorData.invoice.depositBank}}</span>
      </pt-form-item>
      <pt-form-item label="银行账户：" :labelWidth="labelWidth" :lineHeight="lineHeight" :labelColor="labelColor">
        <span>{{vendorData.invoice.depositBankAccount}}</span>
      </pt-form-item>
    </div>
    <div class="marginTop">
      <el-button type="primary" @click="goEdit(vendorData)">编辑</el-button>
      <el-button type="primary" plain @click="cancel">取消</el-button>
    </div>
  </div>
</template>

<script>
// 组件class前缀
import { formatInvoiceType, formatInvoiceProvideType } from 'enumeration/mall'
const prefixCls = 'pt-customer-detail'
export default {
  name: 'pt-customer-detail',
  props: {
    vendor: {
      type: Object,
      default: () => {
        return {
          base: {}
        }
      }
    }
  },
  computed: {
    classes () {
      return `${prefixCls}`
    }
  },
  watch: {
    vendor (val) {
      this.vendorData = val
    }
  },
  data () {
    return {
      labelWidth: '150px',
      lineHeight: '26',
      labelColor: '#409eff',
      vendorData: this.vendor
    }
  },
  methods: {
    formatInvoiceType,
    formatInvoiceProvideType,
    goEdit (data) {
      this.$router.push(`/customer-manage/customer-form/true/${data.id}`)
    },
    cancel(){
      history.go(-1)
    }
  }
}
</script>

<style module lang="less">
@import '~less/var.less';
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
.quaImages{
  width:204px;
        height: 128px;
}
.pictureNames{
    display: flex;
    margin:0;
    padding-left: 0;
    li{
      width:204px;
      line-height: 20px;
      text-align: center;
    }
  }
  .special{
    color:@mainColor;
    text-decoration: none;
  }
</style>
